import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Activity icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Activity } from '@sravni/design-system-icons'
 *
 * <Activity />
 * ```
 */
var Activity = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Activity", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m6.049 10-1.875 1.875L2.299 10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.174 10c0 .578.071 1.138.196 1.68M19.174 10a7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-7.5 7.5M11.674 17.5a7.5 7.5 0 0 0 7.5-7.5M5.531 14.296a7.485 7.485 0 0 0 6.143 3.204", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m14.483 12.393-3.043-1.811V6.654", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Activity };
//# sourceMappingURL=Activity.js.map
